import { FC } from 'react'
import { Tabs, Typography } from 'antd'
import {
	RiBarChartBoxFill,
	RiCodeLine,
	RiContactsBookFill,
	RiDownload2Fill,
	RiMessage2Fill,
	RiQuestionFill,
} from 'react-icons/ri'

import BroadcastContacts from 'component/Broadcast/BroadcastContacts'
import useBroadcastContacts from 'hooks/useBroadcastContacts'
import BroadcastDownloads from 'component/Broadcast/BroadcastDownloads'
import BroadcastEnquiries from 'component/Broadcast/BroadcastEnquiries'
import BroadcastDetails from 'component/Broadcast/BroadcastDetails'
import BroadcastFormReplies from 'component/Broadcast/BroadcastReplies'

import ReactJson from 'react-json-view'
import useSingleBroadcast from 'hooks/useSingleBroadcast'
import styles from './styles.module.scss'

const { TabPane } = Tabs
const { Text } = Typography

const BroadcastTabs: FC = () => {
	const { refresh } = useBroadcastContacts()
	const { broadcast } = useSingleBroadcast()

	return (
		<Tabs
			className={styles.tabs}
			onChange={key => {
				// if contacts tab selected refresh contacts
				if (key === '1') {
					refresh()
				}
			}}
		>
			<TabPane
				tab={
					<Text className={styles.tabPane}>
						<RiContactsBookFill size={18} />
						Contacts
					</Text>
				}
				key='1'
			>
				<BroadcastContacts />
			</TabPane>
			<TabPane
				tab={
					<Text className={styles.tabPane}>
						<RiBarChartBoxFill size={18} />
						Broadcast Details
					</Text>
				}
				key='2'
			>
				<BroadcastDetails />
			</TabPane>
			<TabPane
				tab={
					<Text className={styles.tabPane}>
						<RiDownload2Fill size={18} />
						Downloads
					</Text>
				}
				key='3'
			>
				<BroadcastDownloads />
			</TabPane>
			<TabPane
				tab={
					<Text className={styles.tabPane}>
						<RiQuestionFill size={18} />
						Enquiries
					</Text>
				}
				key='4'
			>
				<BroadcastEnquiries />
			</TabPane>
			<TabPane
				tab={
					<Text className={styles.tabPane}>
						<RiMessage2Fill size={18} />
						Replies
					</Text>
				}
				key='5'
			>
				<BroadcastFormReplies />
			</TabPane>
			<TabPane
				tab={
					<Text className={styles.tabPane}>
						<RiCodeLine size={18} />
						JSON
					</Text>
				}
				key='6'
			>
				<ReactJson
					src={broadcast ?? {}}
					theme='google'
					indentWidth={8}
					name={false}
					style={{
						padding: '1.6rem',
						borderRadius: '.8rem',
					}}
				/>
			</TabPane>
		</Tabs>
	)
}

export default BroadcastTabs
